<template>
    <div id="popup-container">
        <div class="popup-mask"
             @click.prevent="closePopUp"
        >
        </div>
        <div class="content">
            <iframe frameborder="0"
                    :src="bookInfoState.popupHtmlData.url"
                    :width="popupWidth"
                    :height="popupHeight"
                    v-if="bookInfoState.popupHtmlData"
                    @load="popupHtmlOnLoaded"
            >
            </iframe>
            <img :src="`${bookInfoState.publicPath}/${bookInfoState.popupImageData.url}`"
                 :width="popupWidth"
                 :height="popupHeight"
                 v-if="bookInfoState.popupImageData"
            />
            <a href="#"
               class="btn-close hover-effect"
               @click.prevent="closePopUp"
            >
                <img class="full-size" src="~images/btn_close.svg">
            </a>
        </div>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUpdated, watchEffect, computed, onUnmounted}  from "vue"
    import config from "@/config/config.json";
    import {usePaging}  from "@/modules/reader/book/paging";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import cssvar from '@/scss/_variables.scss';

    export default {

        setup(props, context) {

            const {pageResizeState, zoomIn, zoomOut} = usePageResize();
            const {pageState}  = usePaging();
            const {bookInfoState, toggleSpeech, toggleGlobalHan, toggleGlobalPinYin, removePopupHtmlData, removePopupImgaeData} = useBookInfo();

            const readerWidth = ref(null);
            const readerHeight = ref(null);
            const popupContentRatio = ref(null);
            const popupWidth = ref(0);
            const popupHeight = ref(0);
            const footerHeight =  parseInt(cssvar.footerHeight)
            const headerHeight = parseInt(cssvar.headerHeight)


            const closePopUp = ()=>{
                if (bookInfoState.popupHtmlData) {
                    removePopupHtmlData();
                }

                if (bookInfoState.popupImageData) {
                    removePopupImgaeData();
                };
            }

            const windowOnResized = ()=> {

                readerWidth.value = document.body.clientWidth;
                readerHeight.value = document.body.clientHeight - headerHeight - footerHeight;
                limitPopupSize();
            }

            /**
             * Limit the popup image size not to exceed the reader viewport
             */
            const limitPopupSize = ()=>{

                if (popupWidth.value  >  readerWidth.value) {
                    popupWidth.value = readerWidth.value *  config.reader.popupResourceScaleBuffer;
                    popupHeight.value =  popupWidth.value  / popupContentRatio.value;
                }

                if (popupHeight.value > readerHeight.value) {
                    popupHeight.value = readerHeight.value *  config.reader.popupResourceScaleBuffer;
                    popupWidth.value = popupHeight.value  * popupContentRatio.value;

                }
            }

            /**
             * To prevent scrollbar from rendering
             */
            const popupHtmlOnLoaded = (e)=> {
                let doc =  e.currentTarget.contentDocument?  e.currentTarget.contentDocument:  e.currentTarget.contentWindow.document;
                let body = doc.getElementsByTagName("body")
                if (body) {
                    body[0].style.overflow = "hidden";
                }
            }

            /**
             * Update the popup content width and height regarding zoom level
             */
            const setContentSize = (width, height)=> {
                popupContentRatio.value = width / height;
                popupWidth.value = width * pageResizeState.zoomLevel;
                popupHeight.value =  height * pageResizeState.zoomLevel;
            }

            onUnmounted(()=>{
                document.removeEventListener("keydown", (e)=> {
                    if (e.keyCode === 27) {
                        closePopUp();
                    }
                })

                console.log("unmounted!!")
            })

            watchEffect(()=>{

                document.addEventListener("keydown", (e)=> {
                    if (e.keyCode === 27) {
                        closePopUp();
                    }
                })

                if (bookInfoState.popupImageData) {
                    /*popupContentRatio.value = bookInfoState.popupImageData.size.width / bookInfoState.popupImageData.size.height;
                    popupWidth.value = bookInfoState.popupImageData.size.width * pageResizeState.zoomLevel;
                    popupHeight.value = bookInfoState.popupImageData.size.height * pageResizeState.zoomLevel;*/
                    setContentSize(bookInfoState.popupImageData.size.width, bookInfoState.popupImageData.size.height);
                } else if (bookInfoState.popupHtmlData) {
                    /*popupContentRatio.value = bookInfoState.popupHtmlData.size.width / bookInfoState.popupHtmlData.size.height;
                    popupWidth.value = bookInfoState.popupHtmlData.size.width * pageResizeState.zoomLevel;
                    popupHeight.value = bookInfoState.popupHtmlData.size.height * pageResizeState.zoomLevel;*/
                    setContentSize(bookInfoState.popupHtmlData.size.width, bookInfoState.popupHtmlData.size.height);
                }

                    window.addEventListener("resize", (e)=>{
                        windowOnResized();
                    })

                    windowOnResized();
            });

            return {
                pageResizeState,
                bookInfoState,
                removePopupHtmlData,
                removePopupImgaeData,
                popupWidth,
                popupHeight,
                readerWidth,
                readerHeight,
                limitPopupSize,
                closePopUp,
                popupHtmlOnLoaded
            }
        }
    }
</script>


<style scoped lang="scss">

    #popup-container{
        position:fixed;
        display:flex;
        justify-content:center;
        align-items:center;
        left:0;
        top:0;
        width:100%;
        height:100%;
        z-index:$zindex-popup-container;
    }

    .content {
        position:relative;
        border:10px solid #ccc;
        border-radius:10px;
        box-shadow: 1px 4px 8px #999;
    }

    .popup-mask {
        position:fixed;
        background:#000;
        opacity:0.3;
        width:100%;
        height:100%;
    }

    .btn-close {
        position:absolute;
        width: 22px;
        height: 22px;
        top: -16px;
        right: -16px;
    }
</style>